import snoopySdk from './snoopy-sdk';

export default snoopySdk;
